import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';


export const Api = createApi({
    baseQuery: fetchBaseQuery({
        baseUrl: process.env.REACT_APP_API_URL as string,
    }),
    endpoints: (builder) => ({}),
});